export const sidebarLimitValidator = (value: unknown, defaultValue: number) => {
  return typeof value == 'number' && !Number.isNaN(value) && value >= 0
    ? value
    : defaultValue;
};
